import React from 'react'
import { useIntl } from 'react-intl'

import * as Analytics from 'analytics/analytics'
import BodyText from 'LuxKit/Typography/BodyText'
import Modal from 'LuxKit/Modal/Modal'

function RefreshSearchModal() {
  const intl = useIntl()

  return (
    <Modal
      title={intl.formatMessage({
        id: '5RrAVbn25R',
        defaultMessage: 'Your search session has expired',
        description: 'Title for the expired search session modal',
      })}
      primaryActionText={intl.formatMessage({
        id: '9NbTqE9zrH',
        defaultMessage: 'Refresh',
        description: 'Refresh button label to reload search results',
      })}
      onPrimaryActionClick={() => {
        Analytics.trackClientEvent({
          subject: 'expired',
          action: 'refresh',
          category: 'search',
          type: 'interaction',
        })
        window.location.reload()
      }}
    >
      <BodyText variant="large">
        {intl.formatMessage({
          id: 'LDEV7KxnCr',
          defaultMessage: 'Refresh your search to see available offers.',
          description: 'Body text explaining the search needs refreshing to see offers',
        })}
      </BodyText>
    </Modal>
  )
}

export default RefreshSearchModal
